"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _reactTopLoadingBar = _interopRequireDefault(require("react-top-loading-bar"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _UiContext = _interopRequireDefault(require("../../context/UiContext"));
var _PageTransition = _interopRequireDefault(require("./PageTransition.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PageTransition = function PageTransition(_ref) {
  var _theme$palette, _theme$palette$second;
  var children = _ref.children,
    color = _ref.color,
    _ref$disableTransitio = _ref.disableTransition,
    disableTransition = _ref$disableTransitio === void 0 ? false : _ref$disableTransitio,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "top" : _ref$position,
    _ref$showLoadingBar = _ref.showLoadingBar,
    showLoadingBar = _ref$showLoadingBar === void 0 ? true : _ref$showLoadingBar,
    LoadingBarProps = _ref.LoadingBarProps;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useContext = (0, _react.useContext)(_UiContext.default),
    _useContext2 = _slicedToArray(_useContext, 1),
    ui = _useContext2[0];
  var _ref2 = ui || {},
    _ref2$_loading = _ref2._loading,
    _loading = _ref2$_loading === void 0 ? false : _ref2$_loading;
  var location = (0, _reactRouterDom.useLocation)();
  var hash = location.hash,
    pathname = location.pathname;
  var loaderRef = (0, _react.useRef)(null);
  var startTimer = (0, _react.useRef)(null);
  var theme = (0, _useTheme.default)();
  var css = (0, _PageTransition.default)();
  (0, _react.useEffect)(function () {
    if (showLoadingBar && loaderRef !== null && loaderRef !== void 0 && loaderRef.current) loaderRef.current.continuousStart();
    startTimer.current = new Date();
    setLoading(true);
    if (hash) {
      var elementToScroll = document.getElementById(hash === null || hash === void 0 ? void 0 : hash.replace("#", ""));
      if (elementToScroll) {
        setTimeout(function () {
          window.scrollTo({
            top: elementToScroll.offsetTop - offset,
            behavior: "smooth"
          });
        }, 100);
        return;
      }
    } else {
      window.scrollTo({
        top: 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, offset]);
  (0, _react.useEffect)(function () {
    var timeout = null;
    if (!_loading) {
      var differenceToOneSecond = 300 - (new Date().getTime() - startTimer.current.getTime());
      var timer = differenceToOneSecond > 0 ? differenceToOneSecond : 0;
      timeout = setTimeout(function () {
        if (showLoadingBar && loaderRef !== null && loaderRef !== void 0 && loaderRef.current) loaderRef.current.complete();
        setLoading(false);
      }, timer);
    }
    return function () {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_loading, showLoadingBar]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: pathname
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)(_defineProperty({}, css.hide, !disableTransition && loading))
  }, children), showLoadingBar && /*#__PURE__*/_react.default.createElement(_reactTopLoadingBar.default, _extends({
    color: color ? color : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$second = _theme$palette.secondary) === null || _theme$palette$second === void 0 ? void 0 : _theme$palette$second.main,
    containerClassName: (0, _clsx3.default)(_defineProperty({}, css.positionBottom, position === "bottom")),
    height: 5,
    ref: loaderRef,
    shadow: false
  }, LoadingBarProps)));
};
PageTransition.propTypes = {
  color: _propTypes.default.string,
  disableTransition: _propTypes.default.bool,
  offset: _propTypes.default.number,
  position: _propTypes.default.oneOf(["bottom", "top"]),
  showLoadingBar: _propTypes.default.bool,
  LoadingBarProps: _propTypes.default.object
};
var _default = PageTransition;
exports.default = _default;